import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ConsentGatedAnalytics from './components/common/ConsentGatedAnalytics';
import { ThemeProvider } from './contexts/ThemeContext';
import reportWebVitals from './reportWebVitals';
import { initializeMonitoring } from './utils/monitoringBootstrap';

// Initialize monitoring services
initializeMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <ConsentGatedAnalytics />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
